import React from 'react';
import PropTypes from 'prop-types';
import popup from '../../../popup';
import _ from 'lodash';
import './style.scss';
import '../fitness-modal.scss';
import '~/assets/css/fitness-globals.scss';
import FbButton from './fb-button';
import { getEmailExists } from '~/services/userService';
import {login, signup, fbLogin} from '~/redux/user/actions';
import userStore from '~/redux/user/store';
import { forgotPassword } from '~/redux/user/helpers';
import ResetForm from '~/modules/ResetPassword/resetForm';
import { validateEmail } from '~/tools/validateEmail';
import socialHelpers from '../../socialHelpers';
import Background from './neou_signin.png';
import { pushFinishRegistrationEvent } from '~/services/analyticsService';


//screen states
const [
	DEFAULT, 
	SIGN_IN, 
	CREATE_ACCOUNT, 
	FORGOT_PASSWORD, 
	FORGOT_PASSWORD_SENT,
	RESET_PASSWORD
] = [
	'DEFAULT', 
	'SIGN_IN', 
	'CREATE_ACCOUNT', 
	'FORGOT_PASSWORD', 
	'FORGOT_PASSWORD_SENT',
	'RESET_PASSWORD'
]

/*
	This is the login, create account, forgot password modal for Neou1.5.
	It contains hardcoded images and a hardcoded link.
	To use with other clients will require changing these values.
*/
class SignInCreate extends React.Component {

	constructor(props){
		super(props);
		
		this.state = {
			email: '',
			password: '',
			currentScreen: props.args.currentScreen || DEFAULT,
			loading: false,
			error: false,
			errorMessage: ''
		}
	}

	componentDidMount(){
		socialHelpers.initializeFacebookLogin()
	}

	handleInputChange(e) {
		e.preventDefault();
    	this.setState({[e.target.name]: e.target.value});
	}

	handleSubmitEmail(e){
		e.preventDefault();

		if(validateEmail(this.state.email)){
			getEmailExists(this.state.email).then((res) =>{
				this.setState({loading: false});
				// if(res === undefined){
				// 	//Enter error state
				// }
				if(res){
					this.setState({currentScreen: SIGN_IN});
				}
				else{
					this.setState({currentScreen: CREATE_ACCOUNT});
				}
	
			});
			this.setState({loading: true});
		} else {
			this.setState({error: true})
		}
	}

	handleFacebookLogin() {
		window.FB.login( res => {
	      	var accessToken = res && res.authResponse && res.authResponse.accessToken
	      	if (!accessToken){
	        	return this.alert('Facebook login failed')
	      	}
	      	userStore.dispatch(fbLogin({
	        	facebookToken: accessToken,
	        	emailConsent: true
	      	})).then( res => {
				this.props.onClose();
	      	});
	    }, { scope: 'email, public_profile' })
	}

	handleSignIn(e) {
		e.preventDefault();
		userStore.dispatch(login({email: this.state.email, password: this.state.password}))
		.then( res => {
			//redirect to home page if signed in after reset password
			if(window.location.href.includes('pw=passwordUpdated')) {
				window.location = '/home';
			}
			this.props.onClose();
		})
		.catch( error => {
			if(error.response.status === 401){
				this.setState({error: true, errorMessage: 'Password is incorrect', loading: false});
			}
		})
		this.setState({loading: true});
	}

	handleCreateAccount(e) {
		e.preventDefault();
		userStore.dispatch(signup({email: this.state.email, password: this.state.password}))
		.then( (res) => {
			pushFinishRegistrationEvent();
			this.props.onClose();
			popup.fitnessChooseAPlan({
				showCloseButton: false
			});
		}).catch( error => {
			if(error.response.status === 401){
				this.setState({error: true, errorMessage: error.response.data.error, loading: false});
			}
		});
		this.setState({loading: true});
	}

	handleForgotPassword(e) {
		e.preventDefault();
		forgotPassword(this.state.email).then(res => {
			this.setState({loading: false});
			if(res.data.emailSent){
				this.setState({currentScreen: FORGOT_PASSWORD_SENT});
			}
		}).catch(e => {
				this.setState({loading: false});
		});
		this.setState({loading: true});
	}

	goToForgotPassword() {
		this.setState({currentScreen: FORGOT_PASSWORD});
	}

	goToDefault() {
		this.setState({email: '', password: '', error: false, errorMessage: '', currentScreen: DEFAULT});
	}

	renderContent() {
		switch(this.state.currentScreen){
			case SIGN_IN:
				return this.renderSignIn();
			case CREATE_ACCOUNT:
				return this.renderCreateAccount();
			case FORGOT_PASSWORD:
				return this.renderForgotPassword();
			case FORGOT_PASSWORD_SENT:
				return this.renderForgotPasswordSent();
			case RESET_PASSWORD:
				return this.renderResetPassword() 
			default:
				return this.renderDefault();
		}
	}

	renderDefault(){
		return (
			<div className="modal-content">
				<h1>Sign In or<br/>Create an Account</h1>
				<form onSubmit={this.handleSubmitEmail.bind(this)}>
					<input name="email" placeholder="E-mail Address" value={this.state.email} onChange={this.handleInputChange.bind(this)}/>
					{this.state.error && <div className="error">Enter a valid email address</div>}
					<button className="primary-button black" disabled={this.state.loading}>CONTINUE</button>
				</form>
				<div className="button-divider"><hr/>OR<hr/></div>
				<button className="fb-button" onClick={this.handleFacebookLogin.bind(this)} disabled={this.state.loading}><FbButton/></button>
			</div>
		);
	}

	renderSignIn() {
		return (
			<div className="modal-content">
				<h1>Welcome Back!</h1>
				<p>Enter your password to sign in</p>
				<form onSubmit={this.handleSignIn.bind(this)}>
					<input name="password" type="password" placeholder="Password" value={this.state.password} onChange={this.handleInputChange.bind(this)}/>
					{this.state.error && <div className="error">{this.state.errorMessage}</div>}
					<button className="primary-button black" disabled={this.state.loading}>SIGN IN</button>
				</form>
				<a className="link-back" onClick={this.goToForgotPassword.bind(this)}>RESET PASSWORD</a>
			</div>
		);
	}

	renderCreateAccount(){
		return (
			<div className="modal-content">
				<h1>Hello!</h1>
				<p>Add a password to set up your account</p>
				<form onSubmit={this.handleCreateAccount.bind(this)}>
					<input name="password" type="password" placeholder="Password (5+ characters)" value={this.state.password} onChange={this.handleInputChange.bind(this)}/>
					{this.state.error && <div className="error">{this.state.errorMessage}</div>}
					<button className="primary-button black" disabled={this.state.loading}>CREATE ACCOUNT</button>
				</form>
				<p className="legal-text">By signing up you are agreeing to our <a href="/tos">Terms of Service</a>.</p>
			</div>
		);
	}

	renderForgotPassword(){
		return (
			<div className="modal-content">
				<h1>Forgot Your Password</h1>
				<p>Enter the e-mail address you used to create your NEOU account.</p>
				<form onSubmit={this.handleForgotPassword.bind(this)}>
					<input name="email" placeholder="E-mail Address" value={this.state.email} onChange={this.handleInputChange.bind(this)}/>
					<button className="primary-button black" disabled={this.state.loading}>RESET PASSWORD</button>
				</form>
				<a className="link-back" onClick={this.goToDefault.bind(this)}>CANCEL</a>
			</div>
		);
	}

	renderForgotPasswordSent(){
		return (
			<div className="modal-content">
				<h1>Password Forgot Sent!</h1>
				<p>Check your email in the next few minutes and click on the link provided.</p>
				<button className="primary-button black" onClick={this.goToDefault.bind(this)} disabled={this.state.loading}>BACK TO SIGN IN</button>
			</div>
		);
	}

	renderResetPassword() {
		return (
			<div className="modal-content">
				<ResetForm simplified={true} />
			</div>
		)
	}

	closeModal = () => {
		this.props.onClose()
		if (window.location.pathname === '/reset-password') {
			window.location = '/'
		}
		//Hack to handle using modal on /viewplans
		if(window.location.pathname === '/viewplans'){
			window.location.href = "/home";
		}
	}

	render() {
		return (
			<div className="fitness-signin-create fitness-modal" style={{backgroundImage: `url(${Background})`}}>
				<img className="logo-image" src={ _.get(window.settings, 'images.desktopLogo') } alt="Logo" />
				{this.renderContent()}
		  	</div>
		)
	}
}

SignInCreate.propTypes = {
  onClose: PropTypes.func
};

export default SignInCreate;